import { ChainID, ChainSubType } from '@ankr.com/chains-list';

import { useIsMDDown } from 'uiKit/Theme/useTheme';
import { ChainGroupID } from 'modules/endpoints/types';

import { GroupSelect } from '../GroupSelect';
import { GroupTabs, MIN_GROUP_TABS } from '../GroupTabs';
import { useChainSelectors } from '../ChainSelectorsProvider';

interface GroupSelectorProps {
  className?: string;
  classNameTab?: string;
  classNameTabsInner?: string;
  classNameTabsWrapper?: string;
  disableGroupsWithoutNetwork?: boolean;
}

export const GroupSelector = ({
  className,
  classNameTab,
  classNameTabsInner,
  classNameTabsWrapper,
  disableGroupsWithoutNetwork,
}: GroupSelectorProps) => {
  const { chain, chainSubType, groups } = useChainSelectors();
  const isMobile = useIsMDDown();

  // for merged chain group we should hide the group selector
  // this case is relevant only for endpoints module
  const isHidden = groups[0]?.id === ChainGroupID.MERGED;

  if (isHidden) {
    return null;
  }

  const hasGroupSelect =
    chainSubType === ChainSubType.Athens3 ||
    chain.id === ChainID.TAC ||
    chain.id === ChainID.SEI ||
    chain.id === ChainID.KAVA;

  const hasEnoughGroups = groups.length >= MIN_GROUP_TABS;

  const groupTabsVisible = !hasGroupSelect && hasEnoughGroups;

  const groupSelectVisible =
    (hasGroupSelect && groups.length > 0) || (isMobile && hasEnoughGroups);

  const isGroupTabsVisible = groupTabsVisible && !isMobile;

  return (
    <>
      {isGroupTabsVisible && (
        <GroupTabs
          className={className}
          classNameTab={classNameTab}
          classNameTabsInner={classNameTabsInner}
          classNameTabsWrapper={classNameTabsWrapper}
          visible={isGroupTabsVisible}
        />
      )}
      {groupSelectVisible && (
        <GroupSelect
          className={className}
          disableGroupsWithoutNetwork={disableGroupsWithoutNetwork}
          visible={groupSelectVisible}
        />
      )}
    </>
  );
};
